// extracted by mini-css-extract-plugin
export default {"sectionForm":"fibonacci_sectionForm__vf+ag","input":"fibonacci_input__D8yY2","button":"fibonacci_button__VoHAq","sectionResult":"fibonacci_sectionResult__LqqgJ"};